export const RESULTS_NUMBER_TO_SHOW_CLARIFICATION_TEXT = 10;
